import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import styles from './index.module.scss';
import { Checkbox, Dropdown, Form, Notification, Toast } from '@douyinfe/semi-ui';
import { useRouter } from 'next/router';
import useRequest from '@/utils/useRequest';
import { IndexContext } from '@/stores';
import { debounce } from 'lodash';

interface IProps {
}

export default ({ }) => {
  const router = useRouter()
  const request = useRequest()
  const formRef = useRef<any>()
  const [reload, setReload] = useState<any>('aa')
  const checkbox = useRef<any>()
  const { setIsHeadFoot, getNav, setLang, lang } = useContext(IndexContext);


  const btnClick = useCallback(async () => {

    const { account, password } = formRef.current.getFormState().values
    formRef.current.validate().then(async () => {
      const { data } = await request.post('/exhibitor/do_login', {
        account,
        pwd: password
      })
      // let user = data?.data?.payload || {}
      // localStorage.setItem('token', window.btoa('123'))
      if (data?.code == 1) {
        if (checkbox.current) {
          const user = {
            account, password
          }
          localStorage.setItem('user', window.btoa(JSON.stringify(user)))
        } else {
          localStorage.removeItem('user')
        }
        document.cookie = `exhibitor_token=${data?.data?.jwt}; Expires=${new Date(data?.data?.payload?.expire * 1000).toUTCString()}; Path=/; Secure; SameSite=Lax`;
        getNav('cn')
        // localStorage.setItem('jwt', window.btoa(JSON.stringify(data?.data?.jwt)))
        router.push('/index')
      } else {
        Toast.error(data?.msg)
      }
    }).catch((err: any) => {
      Toast.error(Object.values(err).join(' '))
    })

  }, [])

  const getVerify = useCallback(async () => {
    // const { data } = await axios.get(`/api/get_verify`)
    // setReload('data:image/png;base64,' + arrayBufferToBase64(data?.data?.img?.data))
    // setCookie(data?.data?.cookie)
  }, [])

  useEffect(() => {
    setIsHeadFoot(false)
    // router.push(jwt ? '/index' : '/login')
    return () => {
      setIsHeadFoot(true)
    }
  }, [])
  useEffect(() => {
    const user = localStorage.getItem('user')
    const dec = user && JSON.parse(window.atob(user))
    if (dec) {
      formRef.current.setValues({
        ...dec
      })
    }
  }, [formRef.current])

  return (
    <div className={styles.container}>
      <img className={styles.logo} src="/image/logo-white.png" alt="" />
      <a className={styles.toHome} href="https://www.organic-festa.com/" target='_blank'>返回首页</a>
      <Dropdown
        style={{ width: '175px' }}
        render={
          <Dropdown.Menu>
            <Dropdown.Item onClick={() => setLang('cn')}>中文</Dropdown.Item>
            <Dropdown.Item onClick={() => setLang('en')}>English</Dropdown.Item>
          </Dropdown.Menu>
        }
      >
        <div className={styles.langBtn}>
          <span>语言：</span>{lang === 'cn' ? '中文' : 'English'}
        </div>
      </Dropdown>
      <div className={styles.left}>
        <img src="/image/login-title.png" alt="" />
      </div>
      <div className={styles.right}>
        <h2>展商登录</h2>
        <Form
          getFormApi={(formApi: any) => formRef.current = formApi}
          labelWidth={0}
        >
          <div className={styles.form}>
            <div className={styles.account}>
              <Form.Input
                field="account"
                placeholder='输入账号'
                noLabel
                noErrorMessage
                rules={[
                  { required: true, message: '请输入账号' },
                ]}
              />
            </div>
            <div className={styles.psw}>
              <Form.Input
                field="password"
                type='password'
                placeholder='输入密码'
                noLabel
                noErrorMessage
                rules={[
                  { required: true, message: '请输入密码' },
                ]}
              />
            </div>
            {/* <div className={styles.vcode}>
              <Form.Input
                field="vcode"
                placeholder='输入验证码'
                noLabel
                noErrorMessage
                rules={[
                  { required: true, message: '请输入验证码' },
                ]}
              />
              {reload && <img src={reload} onClick={() => getVerify()} alt="" />}
            </div> */}
          </div>
        </Form>
        <div className={styles.flex}>
          <Checkbox onChange={(e) => checkbox.current = e.target.checked}>
            <p>记住我的用户名</p>
          </Checkbox>
          {/* <span>忘记密码？</span> */}
        </div>
        <div className={styles.login} onClick={debounce(() => btnClick(), 500)}>登录</div>
        <a href="/apply">展位申请</a>
      </div>
      <style jsx global>
        {
          `
            .semi-form-field{
              // padding:0;
            }
            .semi-input-wrapper{
              background-color: transparent;
              border:1px solid #ddd;
              height:54px;              
            }
            .semi-input{
              height:100%;
              padding-right:142px;
            }
            .semi-input-wrapper:hover {
              border: 1px solid #0a4020;
              background:transparent;
            }
            .semi-checkbox-inner,
            .semi-checkbox-inner-display{
              width: 26px;
              height: 26px;
              border-radius: 50% !important;
              transform: scale(1.1);
            }
            .semi-checkbox{
              align-items: center;
            }
            .semi-checkbox-inner-display,
            .semi-checkbox-inner-display:hover{
              display: flex;
              align-items: center;
              justify-content: center;
              background: white !important;
            }
            .semi-checkbox-inner-checked .semi-checkbox-inner-display{
              background:#93d40b;
              box-shadow:none;
            }
            .semi-checkbox-inner-checked span{
              background: #93d40b !important;
              overflow:hidden;
            }
            .semi-checkbox-inner-display:hover{
              background:#93d40b !important;
              border-color:#93d40b !important;
            }
            .semi-checkbox-inner-display .semi-icon{
              font-size:20px;
            }
          `
        }
      </style>
    </div>
  );
};
